/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\option.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */


export const ADD_OPTION = 'ADD_OPTION_';
export const REMOVE_OPTION = 'REMOVE_OPTION_';

export function addOption(id) {
  return {
    type: ADD_OPTION,
    id,
  };
}

export function removeOption(id) {
  return {
    type: REMOVE_OPTION,
    id,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/option.js